import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import logo from '../logo2.png';

const UpdateBankBalance = () => {
    const [accounts, setAccounts] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState('');
    const [balance, setBalance] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        fetchBankAccounts();
    }, []);

    const fetchBankAccounts = async () => {
        const { data, error } = await supabase.from('bank_accounts').select('*');
        if (!error) {
            setAccounts(data);
        }
    };

    const handleUpdateBalance = async (e) => {
        e.preventDefault();

        const { error } = await supabase
            .from('bank_accounts')
            .update({ balance: parseFloat(balance) })
            .eq('id', selectedAccount);

        if (error) {
            setMessage('Error updating balance');
        } else {
            setMessage('Balance updated successfully');
            setBalance('');
            setSelectedAccount('');
        }
    };


    return (
        <div className="update-balance-container">
            <header className="update-balance-header">
                <img src={logo} alt="Kindbridge Investments" className="dashboard-logo" />
                <h1>Update Bank Balance</h1>
            </header>

            <form onSubmit={handleUpdateBalance} className="update-balance-form">
                <label htmlFor="bank-account">Select Bank Account</label>
                <select
                    id="bank-account"
                    value={selectedAccount}
                    onChange={(e) => setSelectedAccount(e.target.value)}
                    className="input-select"
                >
                    <option value="">Select Bank Account</option>
                    {accounts.map((account) => (
                        <option key={account.id} value={account.id}>
                            {account.bank_name} - {account.account_number} (Balance: {account.balance})
                        </option>
                    ))}
                </select>

                <label htmlFor="balance">New Balance</label>
                <input
                    id="balance"
                    type="number"
                    placeholder="New Balance"
                    value={balance}
                    onChange={(e) => setBalance(e.target.value)}
                    className="input-field"
                />

                <button type="submit" className="submit-button">Update Balance</button>
            </form>

            {message && <p className="message">{message}</p>}
        </div>
    );
};

export default UpdateBankBalance;
